import { type AuthenticationServiceCapabilities } from './authentication.types'

export const authenticationService = ({ percentClient }: AuthenticationServiceCapabilities) => ({
  set2FAMandatory: ({ accountId, twoFaMandatory }: { accountId: string; twoFaMandatory: boolean }) =>
    percentClient.post(`/v1/admin/authentication/accounts/${accountId}/two-fa-mandatory`, { twoFaMandatory })
})
